<template>
    <div
        class="p-1 shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
    >
        <MenuBar class="editor__header" :editor="editor" v-if="editor" :only="only" />
        <EditorContent
            :editor="editor"
            class="editor__content prose prose-sm sm:prose lg:prose-lg m-2 focus:outline-none focus:ring-0"
        />
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import MenuBar from './MenuBar.vue';
import Highlight from '@tiptap/extension-highlight';
import Link from '@tiptap/extension-link';

export default {
    emits: ['update:modelValue'],
    components: {
        EditorContent,
        MenuBar,
    },

    props: {
        modelValue: {
            type: String,
            default: '',
        },
        only: {
            type: Array,
            required: false,
            default: () => [],
        },
    },

    data() {
        return {
            editor: null,
        };
    },

    watch: {
        modelValue(value) {
            // HTML
            const isSame = this.editor.getHTML() === value;

            // JSON
            // const isSame = this.editor.getJSON().toString() === value.toString()

            if (isSame) {
                return;
            }

            this.editor.commands.setContent(this.value, false);
        },
    },

    mounted() {
        this.editor = new Editor({
            extensions: [
                StarterKit,
                Highlight,
                Link.configure({
                    openOnClick: false,
                }),
            ],
            content: this.modelValue,
            onUpdate: () => {
                // HTML
                this.$emit('update:modelValue', this.editor.getHTML());

                // JSON
                // this.$emit('input', this.editor.getJSON())
            },
        });
    },

    beforeUnmount() {
        this.editor.destroy();
    },
};
</script>
<style>
.ProseMirror:focus {
    outline: none;
}
</style>
